import React, {
  Dispatch,
  useContext,
  createContext,
  useState,
  SetStateAction,
} from "react";

export interface IThemeContext {
  isDarkMode: boolean;
  setIsDarkMode: Dispatch<SetStateAction<boolean>>;
  transitionPercent: number;
  setTransitionPercent: Dispatch<SetStateAction<boolean>>;
}

const ThemeViewContext = createContext({
  currentMode: false,
  setCurrentMode: (isDarkMode: boolean) => {},
  currentTransitionPercent: 1,
  setCurrentTransitionPercent: (transitionPercent: number) => {},
});

export const useThemeContext = () => {
  return useContext(ThemeViewContext);
};

export const ThemeContext = ({ darkMode, children }: any) => {
  const [isDarkmode, setIsDarkMode] = useState<boolean>(darkMode || false);
  const [transitionPercent, setTransitionPercent] = useState<number>(1);

  return (
    <ThemeViewContext.Provider
      value={{
        currentMode: isDarkmode,
        setCurrentMode: setIsDarkMode,
        currentTransitionPercent: transitionPercent,
        setCurrentTransitionPercent: setTransitionPercent,
      }}
    >
      {children}
    </ThemeViewContext.Provider>
  );
};

export default ThemeContext;
